import FieldInput, {StyledFieldInput} from './FieldInput';

export default FieldInput;
export {StyledFieldInput};
